// extracted by mini-css-extract-plugin
export default {"action":"CustomDialog_action__W+QzD","reset-btn":"CustomDialog_reset-btn__olDiP","apply-btn":"CustomDialog_apply-btn__3XR0x"};